import { motion, AnimatePresence } from "framer-motion";
import { useState } from "react";

function App() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="App">
      <motion.div
        transition={{ layout: { duration: 1, type: "spring" } }}
        Layout
        className="card"
        onClick={() => setIsOpen(!isOpen)}
      >
        <motion.h2 Layout="position">Framer Motion 🚀</motion.h2>
        <AnimatePresence>
          {isOpen && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 1 }}
              exit={{ opacity: 0 }}
              className="expand"
            >
              <p>
                Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                Laboriosam dolore ipsa in facere tempore explicabo autem
                voluptatum. Ipsam, at consequatur.
              </p>

              <p>
                Lorem ipsum dolor, sit amet consectetur adipisicing elit. Ea,
                porro.
              </p>
            </motion.div>
          )}
        </AnimatePresence>
      </motion.div>
    </div>
  );
}

export default App;
